export default {
  name: "VideoPreview",
  data: function data() {
    return {
      visible: false
    };
  },
  props: {
    url: {
      type: String,
      default: ""
    }
  },
  methods: {
    show: function show() {
      this.visible = true;
    }
  }
};